import { Component } from '@angular/core';

@Component({
  selector: 'app-retourne-retour-frns',
  templateUrl: './retourne-retour-frns.component.html',
  styleUrls: ['./retourne-retour-frns.component.scss'],
})
export class RetourneRetourFrnsComponent {}
